module.exports = __webpack_public_path__ + "static/media/partly_cloudy.40bdd005.svg";